module.exports = __webpack_public_path__ + "img/Nachdenklich.6fbcd0b1.jpg";